<p class="font-bold line-height-2" i18n>Please enter the network name(s) you want displayed on the phone.</p>

<rs-guidance-box class="mb-4" i18n>
  Guidance: The text strings entered per record will be stored in EF_PNN (PLMN Network Name) and be used by the wireless devices in
  conjunction with EF_OPL (Operator PLMN List).
</rs-guidance-box>

<div class="ml-6">
  <rs-error-message *ngIf="errorFound" class="mb-3" [message]="errorMessage" />
  <div style="width: 30rem">
    <p-table
      showGridlines="true"
      stripedRows="true"
      [value]="profileValues.networkNames"
      [resizableColumns]="true"
      styleClass="p-datatable-striped p-datatable-gridlines"
    >
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width: 7rem" />
          <col />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th i18n>Record #</th>
          <th>
            <span i18n>Full Name</span>
            <span class="ml-2 font-medium" i18n>(e.g., RiPSIM)</span>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-networkName>
        <tr>
          <td class="text-center">{{ networkName.recordNumber }}</td>
          <td class="px-4">
            <input
              (input)="handleFormEvents()"
              [(ngModel)]="networkName.fullName"
              class="console-text maximize-inputs"
              type="text"
              maxlength="14"
              pInputText
            />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
